import { route } from '../helpers';
import { PointStages, SmartcardPages } from '../../constants/AppConstants';
import urls from "../../urls";
import FeatureFlagStore from "../../stores/FeatureFlagStore";
import UserStore from "../../stores/UserStore";
import CustomerActions from "../../actions/CustomerActions";

module.exports = route(SmartcardPages.SELF_REGISTERED, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/smartcard/SmartcardSelfRegistration').default);
        }, 'smartregister');
    },

    async onEnter (nextState, replace) {
        const user = UserStore.getCurrent();

        if (user && user.isLoggedIn()) {
            await CustomerActions.logout(UserStore.getCurrent());
        }

        if (!FeatureFlagStore.get('enableSmartcardSelfRegistration') || !FeatureFlagStore.get('enableSmartcard')) {
            replace(urls.location(PointStages.SEARCH));
        }
    }
});



// WEBPACK FOOTER //
// ./src/routes/SelfSmartcard/index.js